import { styled, TableCell } from "@mui/material";

export const TableCellNoWrap = styled(TableCell)(({ theme }) => ({
  whiteSpace: "nowrap",
}));
